// Locale → copy for the public "Selfie search and face data from 1 November 2026" page, following the site's
// language like /pricing-changes-2026: English (source of truth), Spanish and Portuguese; any other language falls
// back to English.
import { useTranslation } from "react-i18next";
import { baseLang } from "@/lib/seo/site";
import en, { type FaceDataCopy } from "./copy.en";
import es from "./copy.es";
import pt from "./copy.pt";

/** Where the page lives. Linked from the face-data campaign email (photohawk-serverless
 *  ops/campaigns/face-data-2026-11.json), so don't change it. */
export const FACE_DATA_CHANGES_PATH = "/face-data-changes-2026";

export const FACE_DATA_LANGS = ["en", "es", "pt"] as const;

const COPY_BY_LANG: Record<string, FaceDataCopy> = { en, es, pt };

export const getFaceDataCopy = (lang: string | undefined): FaceDataCopy => COPY_BY_LANG[baseLang(lang)] ?? en;

export function useFaceDataCopy(): { copy: FaceDataCopy; lang: string } {
  const { i18n } = useTranslation();
  const base = baseLang(i18n.language);
  const lang = COPY_BY_LANG[base] ? base : "en";
  return { copy: COPY_BY_LANG[lang], lang };
}

export type { FaceDataCopy };
